<template>
    <div class="contact-float">
        <!-- 联系电话 -->
        <div class="contact-item phone-item">
            <div class="contact-icon">
                <!-- 电话图标图片 -->
                <img src="@/assets/images/phone-icon.png" alt="联系电话" class="icon-img">
            </div>
            <div class="contact-detail phone-detail">
                <p class="detail-title">联系电话</p>
                <p class="detail-content">{{ phone }}</p>
            </div>
        </div>

        <!-- 邮箱 -->
        <div class="contact-item email-item">
            <div class="contact-icon">
                <!-- 邮箱图标图片 -->
                <img src="@/assets/images/email-icon.png" alt="邮箱地址" class="icon-img">
            </div>
            <div class="contact-detail email-detail">
                <p class="detail-title">邮箱地址</p>
                <p class="detail-content">{{ email }}</p>
            </div>
        </div>

        <!-- 微信公众号 -->
        <div class="contact-item wechat-item">
            <div class="contact-icon">
                <!-- 微信图标图片 -->
                <img src="@/assets/images/wechat-icon.png" alt="微信公众号" class="icon-img">
            </div>
            <div class="contact-detail wechat-detail">
                <p class="detail-title">微信公众号</p>
                <div class="qrcode-container">
                    <img :src="qrcodeUrl" alt="公众号二维码" class="qrcode">
                </div>
                <p class="wechat-name">{{ wechatName }}</p>
            </div>
        </div>

        <!-- 回到顶部 -->
        <div class="contact-item top-item" @click="scrollToTop">
            <div class="contact-icon">
                <!-- 回到顶部图标图片 -->
                <img src="@/assets/images/top-icon.png" alt="回到顶部" class="icon-img">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContactFloat',
    props: {
        phone: {
            type: String,
            default: '400-123-4567'
        },
        email: {
            type: String,
            default: 'contact@example.com'
        },
        wechatName: {
            type: String,
            default: '有限元在线'
        },
        qrcodeUrl: {
            type: String,
            default: 'src/assets/images/wechat-qrcode.jpg' // 默认二维码图片路径
        }
    },
    methods: {
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }
    }
}
</script>

<style scoped>
.contact-float {
    position: fixed;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999;
    display: flex;
    flex-direction: column;
    gap: 0;
}

.contact-item {
    position: relative;
    cursor: pointer;
}

.contact-icon {
    width: 40px;
    height: 40px;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

/* 图标图片样式 */
.icon-img {
    width: 24px;
    /* 图片宽度 */
    height: 24px;
    /* 图片高度 */
    object-fit: contain;
    /* 保持图片比例 */
}

.contact-detail {
    position: absolute;
    right: 50px;
    background-color: white;
    padding: 30px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    transform: translateX(10px);
}

.phone-detail,
.email-detail {
    top: 50%;
    transform: translateY(-50%) translateX(10px);
}

.wechat-detail {
    top: 0;
    text-align: center;
    /* width: 140px; */
}

.detail-title {
    margin: 0 0 6px 0;
    color: #333;
    font-size: 13px;
    font-weight: 500;
}

.detail-content {
    margin: 0;
    color: #666;
    font-size: 14px;
}

/* .qrcode-container {
    margin: 0 auto;
} */

.qrcode {
    width: 150px;
    height: 150px;
    display: block;
    /* border:1px solid black; */
}

.wechat-name {
    margin: 6px 0 0 0;
    color: #333;
    font-size: 13px;
}

.contact-item:hover .contact-icon {
    background-color: #e0e0e0;
}

.contact-item:hover .contact-detail {
    opacity: 1;
    visibility: visible;
    transform: translateY(-50%) translateX(0);
}

.wechat-item:hover .contact-detail {
    transform: translateX(0);
}

@media (max-width: 768px) {
    .contact-icon {
        width: 36px;
        height: 36px;
    }

    .icon-img {
        width: 20px;
        height: 20px;
    }

    .contact-detail {
        padding: 10px;
        right: 45px;
    }

    .qrcode {
        width: 90px;
        height: 90px;
    }

    .wechat-detail {
        width: 90px;
    }
}
</style>